import React from "react";
import { Link } from "react-router-dom";
import style from "./landingPage.module.css";
import Music from '../../assets/Music Landing.mp3'

export default function LandingPage() {
  return (
    <div className={style.container}>
      <audio src={Music} autoPlay loop /> 
      <div className={style.contain}>
        <div>
          <h1 className={style.h1}>WELCOME</h1>
          <h1 className={style.h1}>APP</h1>
          <h1 className={style.h1}>COUNTRIES</h1>
          <div >
          <Link to="/home">
            <button className={style.button} >Open</button>
          </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
